<template>
  <div class="dropdown">
    <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false">{{ $t('display_column') }}</a>
    <div class="dropdown-menu">
      <a v-for="(column, index) in columns" class="dropdown-item dropdown-column-item" :class="columnVisible(column) ? 'selected' : ''" href="#" @click.prevent="toggle_column($event,index)"><i class="fa fa-check"></i> {{column.label}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "DisplayColumnsComponent",
  props: {
    columns: {
      type: Array,
      required: true
    },
    table: {
      type: Object,
      required: true
    },
    offset: {
      type: Number,
      default: 2
    }
  },
  methods: {
    columnVisible(column) {
      if (column.hasOwnProperty('definition') && column.definition.hasOwnProperty('visible') && !column.definition.visible) return false
      return true
    },
    toggle_column(event, column_index) {
      // Get the column API object
      let column = this.table.column(column_index + this.offset);

      // Toggle the visibility
      column.visible(!column.visible());

      // adjust dropdown menu
      if (column.visible() && !$(event.target).hasClass('selected')) {
        $(event.target).addClass('selected')
      } else if (!column.visible() && $(event.target).hasClass('selected')) {
        $(event.target).removeClass('selected');
      }
    },
  }
}
</script>

<style scoped>

</style>
